/**
 * @generated SignedSource<<0fc40a07417aa334aa0f8de7f193e7b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteCertificateTemplateInput = {
  clientMutationId?: string | null | undefined;
  ids: ReadonlyArray<string>;
};
export type CertificateTemplatesTable_DeleteCertificateTemplateMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeleteCertificateTemplateInput;
};
export type CertificateTemplatesTable_DeleteCertificateTemplateMutation$data = {
  readonly Admin: {
    readonly Certificates: {
      readonly deleteCertificateTemplate: {
        readonly deletedIds: ReadonlyArray<string>;
      } | null | undefined;
    };
  };
};
export type CertificateTemplatesTable_DeleteCertificateTemplateMutation = {
  response: CertificateTemplatesTable_DeleteCertificateTemplateMutation$data;
  variables: CertificateTemplatesTable_DeleteCertificateTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CertificateTemplatesTable_DeleteCertificateTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CertificatesAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Certificates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteCertificateTemplatePayload",
                "kind": "LinkedField",
                "name": "deleteCertificateTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CertificateTemplatesTable_DeleteCertificateTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CertificatesAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Certificates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "DeleteCertificateTemplatePayload",
                "kind": "LinkedField",
                "name": "deleteCertificateTemplate",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "deletedIds",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "connections"
                      }
                    ]
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a8f9eef26115bab5456dd525237fe15b",
    "id": null,
    "metadata": {},
    "name": "CertificateTemplatesTable_DeleteCertificateTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation CertificateTemplatesTable_DeleteCertificateTemplateMutation(\n  $input: DeleteCertificateTemplateInput!\n) {\n  Admin {\n    Certificates {\n      deleteCertificateTemplate(input: $input) {\n        deletedIds\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44429308c32926cfa7160fc8831b0906";

export default node;
